import { render } from "./SessionDetails.vue?vue&type=template&id=0562c215&scoped=true"
import script from "./SessionDetails.vue?vue&type=script&lang=js"
export * from "./SessionDetails.vue?vue&type=script&lang=js"

import "./SessionDetails.vue?vue&type=style&index=0&id=0562c215&scoped=true&lang=css"

import exportComponent from "/home/peter/new-demo-tool/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0562c215"]])

export default __exports__